import React from "react";
import { AllIcons } from "./IconList";

export default function DynamicIcon({ iconName }: { iconName: string }) {
  //@ts-ignore
  let IconComponent: any = AllIcons["Md" + iconName];
  if (!IconComponent) {
    //@ts-ignore
    IconComponent = AllIcons["Io" + iconName];
  }
  if (!IconComponent) {
    console.error("Non indexed Icon", iconName);
    return (
      <span data-icon={iconName} data-msg={"Icon Not Found..."}>
        {iconName}
      </span>
    );
  }

  return <IconComponent />;
}
